import * as fromRootStore from '../reducers/index'
//import * as fromContacts from './reducers/contacts-reducer';
import * as fromCommon from './reducers/common.reducer';
import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

export interface AppState {
    //contacts: fromContacts.State,
    common: fromCommon.State
}

// This is a lazy loaded state, so we need to extend from the App Root State
export interface State extends fromRootStore.State {
    'appState': AppState
}

export const reducers = {
    //contacts: fromContacts.reducer,
    common: fromCommon.reducer
};

export const getCommonRootState = createFeatureSelector<AppState>('appState');

export const getCommonState = createSelector(
    getCommonRootState,
    (state: AppState) => state.common
);

export const getAuth = createSelector(
    getCommonState,
    fromCommon.getAuth
);

export const getAllBrand = createSelector(
    getCommonState,
    fromCommon.getAllBrand
);

export const getAllBrandModel = createSelector(
    getCommonState,
    fromCommon.getAllBrandModel
);

export const getAllBranch = createSelector(
    getCommonState,
    fromCommon.getAllBranch
);

export const getAllFollowUpStatus = createSelector(
    getCommonState,
    fromCommon.getAllFollowUpStatus
);

export const getAllReference = createSelector(
    getCommonState,
    fromCommon.getAllReference
);

//CONTACT MODULE
// export const getContactsRootState = createFeatureSelector<AppState>('appState');
//
// export const getContactsState = createSelector(
//     getContactsRootState,
//     (state: AppState) => state.contacts
// );
//
//
// export const getAllContacts = createSelector(
//     getContactsState,
//     fromContacts.getAllContacts
// );
//
// export const getCurrentContact = createSelector(
//     getContactsState,
//     fromContacts.getCurrentContact
// );



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/store/index.ts